import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoryNav() {
  return (
    <section className="py-12 md:py-16 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
            热门赛事分类
          </h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-[500px] mx-auto">
            覆盖全球数百种体育赛事，选择您感兴趣的运动类别，即刻开启精彩体育之旅
          </p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center p-6 md:p-8 rounded-xl bg-background-100 hover:bg-primary-50 border border-background-200/60 hover:border-primary-200/60 transition-all duration-300 cursor-pointer"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300">
                <i className={`${cat.icon} text-2xl`}></i>
              </div>
              <h3 className="mt-4 font-heading text-base md:text-lg font-semibold text-foreground-800 group-hover:text-primary-700 transition-colors">
                {cat.name}
              </h3>
              <p className="mt-1 text-xs text-foreground-500">
                {cat.matchCount.toLocaleString()}+ 场赛事
              </p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}